export default "__VITE_ASSET__Lt5$PIUe__"